import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_26: FaireProductEntity = {
  token: "starter_collection_26",
  type: "product",
  name: "Lucid Lemon Olive Oil",
  brandName: "Brightland",
  imageUrl: "",
  priceDollars: 37,
  msrpDollars: 74,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
